import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class LocationService {
    constructor(
        @Inject('Window') private readonly window,
    ) {}

    public getSearch() {
        return this.window.location.search
            .slice(1)
            .split('&')
            .map((p) =>
                p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    }
}
